export { default } from '@shikijs/langs/less'
